<script>
export default {
  props: {
    accesory: {
      type: Object,
      required: true,
    }
  }
}

</script>

<template>
  <div>

    <div class="form-row row light flex items-center tw-mb-1">
      <label class="col-4">{{ $t("home.widgets.list.icat01_attributes.sound_mute") }}</label>
      <div class="form-label col text-mono ">
        {{ accesory.sound_mute ? $t("watches.activated") :  $t("watches.deactivated") }}
      </div>
    </div>

    <div class="form-row row light flex items-center tw-mb-1">
      <label class="col-4">{{ $t("home.widgets.list.icat01_attributes.tension_level") }}</label>
      <div class="form-label col text-mono">

        <span class="fa fa-bolt"></span>
        {{ accesory.tension_level }}
      </div>
    </div>

  </div>
</template>
